<template>
	<main class="main-body">
		<!-- 导航 -->
		<navbar active="1" @changeTab="changeTab"></navbar>
		<!-- 中间内容区域 -->
		<div class="bui-container-home" :class="{en: globalLang === 'en' || globalLang === 'th' || globalLang === 'vi'}">
			<div class="bui-left" :class="{jp: $region === 'jp'}">
				<div v-if="pType === 'questions'">
					<div class="bui-head">
						{{$t('service.userChoseGame')}}：{{seletedGame.game_name}}
						<span class="re-select" @click="reSelectGame">{{$t('service.anewChoseGame')}}</span>
					</div>
					<div class="bui-con">
						<!-- 问题类型选择 -->
						<div class="filter_list">
							<div class="filter_btn" :class="{on:filter==0}" @click="filterType(0)" ga-data="1801001">{{$t('service.all')}}</div>
							<div class="filter_btn" :class="{on:filter==50}" @click="filterType(50)" ga-data="1802001">{{$t('service.game')}}</div>
							<div class="filter_btn" :class="{on:filter==20}" @click="filterType(20)" ga-data="1803001">{{$t('service.myCard')}}</div>
							<div class="filter_btn" :class="{on:filter==30}" @click="filterType(30)" ga-data="1804001">{{$t('service.login')}}</div>
							<div class="filter_btn" :class="{on:filter==10}" @click="filterType(10)" ga-data="1805001">{{$t('service.account')}}</div>
							<div class="filter_btn mr0" :class="{on:filter==70}" @click="filterType(70)" ga-data="1806001">{{$t('service.other')}}</div>

							<search class="search-item" @searchValChanged="changeList" :searchOptions="pageOptions" :searchType="filter" :selGame="seletedGame" :dataFunc="propFunc" :datas="qaList" ref="searchInput"></search>
						</div>
						<!-- 问题item -->
						<qa-item ref="qItem" v-for="(i, index) in qaList" :key="index + new Date().getTime()" :itemData="i"></qa-item>
						<!-- 查看更多 -->
						<div v-if="!no_more" class="show_more_item">
							<div v-if="!btnBusy" @click="getMoreQue">
								{{$t('service.lookMore')}}
								<span class="icon">
									<img src="../images/arrow_down_circle.svg" alt="">
								</span>
							</div>
							<img src="../images/loading.svg" class="loading_icon" v-if="btnBusy">
						</div>
					</div>
				</div>
				<div v-if="pType === 'games'">
					<div class="bui-head">
						{{$t('service.choseGame')}}
					</div>
					<div class="bui-con">
						<div class="bui-box" v-for="game in gameList" :key="game.game_base_id" @click="selectGame(game)">
							<img :src="game.game_logo" class="box-bg">
							<div class="box-cover">
								<img :src="game.game_icon" class="box-icon">
								<div class="box-name">{{game.game_name}}</div>
							</div>
						</div>
						<div class="data-loading" v-if="btnBusy">
							<div class="loading-wrap">
								<img src="../images/loading.svg" class="loading_icon">
							</div>
						</div>
					</div>
					<div class="empty-data" v-if="gameList.length == 0 && !btnBusy">{{ $t('service.emptyData') }}</div>
					<!-- 查看更多 -->
					<div v-if="have_more" class="show_more_item" @click="getMoreGames">
						<div>
							{{$t('service.lookMore')}}
							<span class="icon">
								<img src="../images/arrow_down_circle.svg" alt="">
							</span>
						</div>
					</div>
				</div>
			</div>
			<div class="bui-right" v-if="$region !== 'jp'" :class="{jp: $region === 'jp', en: globalLang === 'en' || globalLang === 'th' || globalLang === 'vi'}">
				<div style="margin-top: 30px; margin-bottom: 20px;" @click="goTo('/service/question')" ga-data="1808001">
					<img src="../images/kefu_help.svg" />
					<span>{{$t('service.serviceHelp')}}</span>
				</div>
				<hr v-if="globalLang !== 'en'">
				<div style="margin-top: 20px;" @click="goTo('/service/info')" ga-data="1809001">
					<img src="../images/kefu_info.svg" />
					<span>{{$t('service.serviceConnectInfo')}}</span>
				</div>
			</div>
		</div>
		<selectgameModal :formData="formData" v-if="isSelectGamePop" @closeModal="closeModal" @nextStep="nextStep"></selectgameModal>
	</main>
</template>

<script>
	import LazyLoad from "vanilla-lazyload";
    
	import navbar from './component/navbar';
	import qaItem from './component/qaItem';
	import search from './component/searchInput';
	import selectgameModal from './component/selectgameModal';
	import { mapGetters } from "vuex";

	export default {
		name: "index",
		data() {
			return {
				gameList: [],
				gameListData: [],
				filter: 0,
				qaList: [],
				pType: 'games',
				seletedGame: null,
				pageOptions: {
					index: 1,
					size: 20,
					query: ''
				},
				no_more: false,
				have_more: false,
				gameOptions: {
					index: 1,
					size: 10
				},
				propFunc: this.$apis.service.commonQuestionList,
				docScrollTop: 0,
				btnBusy: false,
				isSelectGamePop: false,
				formData: {
					game_base_id: '',
					type: 1,
					url: ''
				}
			};
		},
		computed: {
		...mapGetters(["userInfo"])
		},
		components: {
			navbar,
			qaItem,
			search,
			selectgameModal
		},
		methods: {
			getMoreGames (){
				this.gameList = this.gameList.concat(this.gameListData.slice(
					this.gameOptions.index * this.gameOptions.size,
					(this.gameOptions.index + 1) * this.gameOptions.size
				));
				if((this.gameOptions.index + 2) * this.gameOptions.size > this.gameListData.length){
					this.have_more = false;
				}
				this.gameOptions.index++;
			},
			changeList (arr, val, tag){
				this.docScrollTop = 0;

				var _this = this;
				_this.qaList = [];				
				if(arr && arr.length === this.pageOptions.size){
					this.no_more = false;
				} else{
					this.no_more = true;
				}
				if(tag === 'selectedSingle'){
					this.no_more = true;
				}
				if(val){
					this.pageOptions.query = val;
				}
				if(arr === 'getData'){
					_this.fetchData(_this.seletedGame);
				}else{
					this.qaList = arr;
					this.$nextTick(() => {
						new LazyLoad({
							elements_selector: ".lazy",
							callback_load: () => {
								_this.$emit('loadedImg');
								_this.$refs['qItem'].forEach(ele => {
									ele.updateBox();
								});
							}
						});
					});
				}
			},
			reSelectGame (){
				this.pType = 'games';
				this.filter = 0;
				this.docScrollTop = 0;
				this.$refs['searchInput'].resetInput();
				this.pageOptions.query = '';
				this.no_more = false;
				this.pageOptions.index = 1;
			},
			selectGame (game){
				this.docScrollTop = 0;
				this.fetchData(game, 'select');
			},
			getMoreQue (){
				this.docScrollTop = document.documentElement.scrollTop;

				this.pageOptions.index++;
				this.fetchData(this.seletedGame, 'more');
			},
			fetchData (game, tag){

				if(this.btnBusy){
					return;
				}

				var _this = this;
				var type = this.filter;
				if(type === 0){
					type = '';
				}

				this.btnBusy = true;
				this.$apis.service.commonQuestionList(game.game_base_id, type, this.pageOptions.index, this.pageOptions.size, this.pageOptions.query).then( res => {
					if(!tag){
						_this.qaList = [];
					}

					this.btnBusy = false;

					if(res.data.data && res.data.data.result){
						if(res.data.data.result.length > 0){
							var cache = res.data.data.result;

							// 将内容中的图片加上类名class，同时替换src为data-src
							cache.forEach(ca => {
								ca.question_content.replace('<img', '<img class="lazy"').replace(' src=', ' data-src=');
							});

							if(tag && tag === 'more'){
								_this.qaList = _this.qaList.concat(cache);
							}else{
								_this.qaList = cache;
							}

							if(cache.length < _this.pageOptions.size){
								_this.no_more = true;
							}

							if(tag && tag === 'select'){
								window.scrollTo(0, 0);
							}
							_this.pType = 'questions';
							_this.seletedGame = game;

							_this.$nextTick(() => {
								new LazyLoad({
									elements_selector: ".lazy",
									callback_load: () => {
										_this.$emit('loadedImg');
										_this.$refs['qItem'].forEach(ele => {
											ele.updateBox();
										});
									}
								});

								if(tag && tag === 'more'){
									_this.intervalCheck(_this.docScrollTop);
								}

							});
						}else{
							_this.no_more = true;
						}
					}
				});
			},
			intervalCheck (pos){
				window.scrollTo(0, pos);

				setTimeout(() => {
					if(document.documentElement.scrollTop !== pos){
						this.intervalCheck(pos);
					}
				}, 100)
			},
			filterType(i) {
				this.filter = i;
				this.no_more = false;
				this.pageOptions.index = 1;
				this.pageOptions.query = '';
				this.docScrollTop = 0;

				this.$refs['searchInput'].resetInput();

				this.fetchData(this.seletedGame);
			},
			goTo(url) {
				this.formData.url = url;				
				// 判断是否登录
				if (this.userInfo && this.userInfo.mid) {
					this.nextStep();
				} else {
					this.isSelectGamePop = true;
				}
			},
			// 关闭选择游戏弹窗
			closeModal() {
				this.isSelectGamePop = false;
				this.formData.url = '';
				this.formData.game_base_id = '';
			},
			// 跳转路由
			nextStep() {
				// 判断有没有登录
				if (this.userInfo && this.userInfo.mid) {
					this.$router.push({
						path: this.formData.url,
						query: this.formData.game_base_id
					});
				} else {
					this.goLogin(this.formData.type);
				}
			},
			// 切换导航栏
			changeTab(url) {
				this.formData.url = url;
				// 判断是否登录
				if (this.userInfo && this.userInfo.mid) {
					this.nextStep();
				} else {
					this.isSelectGamePop = true;
				}
			},
			// 去登录
      goLogin(gameType) {
        let url;
		const redirect = this.formData.game_base_id ? encodeURIComponent(`${location.origin}${this.formData.url}?game_base_id=${this.formData.game_base_id}`) : encodeURIComponent(`${location.origin}${this.formData.url}`);
        if (gameType === 2) { // 新游戏
          url = `https://${this.$siteConfig.passportDomain}/login/?type=both&redirect=${redirect}`;
        } else { // 老游戏
          url = `https://${this.$siteConfig.passportDomain}/login/?redirect=${redirect}`;
        }
        window.location.href = url;
      }
		},
		created() {
			// 获取游戏列表
			this.$apis.service.commonGameList().then((res) => {
				if (res.data.code == 0) {
					if(res.data.data){
						this.gameListData = res.data.data;

						if(res.data.data.length > this.gameOptions.size){
							this.have_more = true;
							this.gameList = this.gameListData.slice(0, this.gameOptions.size);
						}else{
							this.gameList = this.gameListData;
						}
					}
				}
			});
		}
	};
</script>

<style lang="scss" scoped>
	.main-body {
		min-height: calc(100vh - 242px);
	}
	/deep/ input {
		outline: none;
	}
	/deep/ .bui-container-home {
		margin: 0 auto 120px;
		width: 1170px;
		font-size: 0;
		&.en {
			.bui-left {
				width: 870px;
				margin-right: 10px;
			}
			.bui-right {
				width: 290px;
				margin-left: 0;
			}
			.filter_list {
				width: 870px;
			}
			.filter_list .filter_btn {
				margin-right: 5px;
				width: auto;
				padding: 0 15px;
			}
		}
		.empty-data {
			position: relative;
			top: 20px;
			text-align: center;
			font-size: 14px;
			color: #BDBDBD;
		}
		.data-loading {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			padding-top: 40px;
			opacity: 0;
			box-sizing: border-box;
			animation: loading 0.4s forwards;
			.loading-wrap {
				position: relative;
				width: 100%;
				height: 100%;
				background-color: rgba(255, 255, 255, .6);
				.loading_icon {
					position: absolute;
					top: 50%;
					left: 50%;
					width: 90px;
					height: 90px;
					transform: translate(-50%, -50%);
				}
			}
		}
		.search-item {
			float: right;
			width: 230px;
			height: 30px;
			font-size: 14px;
		}
		.bui-left {
			position: relative;
			display: inline-block;
			padding-top: 40px;
			width: 830px;
			&.jp {
				.bui-head {
					text-indent: 0;
					&::before {
						display: none;
					}
				}
			}
			.bui-head {
				position: relative;
				margin-bottom: 30px;
				line-height: 20px;
				font-size: 14px;
				text-indent: 16px;
				color: #444;
				&:before {
					position: absolute;
					top: 0;
					left: 0;
					width: 4px;
					height: 20px;
					content: ' ';
					background: #50BBE5;
					border-radius: 9.5px;
				}
				.re-select {
					margin-left: 10px;
					color: #50BBE5;
					font-size: 12px;
					cursor: pointer;
					&:hover {
						text-decoration: underline;
					}
				}
			}
			.show_more_item{
				text-align: center;
				font-size: 16px;
				line-height: 80px;
				color: #444444;
				cursor: pointer;
				&.gray{
					color: #cccccc;
				}
				img{
					width: 12px;
				}
				.loading_icon {
					display: inline-block;
					width: 30px;
					height: 30px;
				}
			}
			.bui-con {
				overflow: hidden;
			}
			.bui-box {
				position: relative;
				float: left;
				margin-right: 40px;
				margin-bottom: 38px;
				width: 250px;
				height: 142px;
				border: 1px solid #EEEEEE;
				border-radius: 10px;
				box-sizing: border-box;
				overflow: hidden;
				cursor: pointer;
				&:nth-child(3n){
					margin-right: 0;
				}
				.box-bg {
					display: block;
					width: 100%;
					height: 100%;
				}
				.box-cover {
					position: absolute;
					z-index: 2;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					border-radius: 10px;
					transition: all 0.3s;
					.box-icon {
						display: inline-block;
						width: 64px;
						height: 64px;
						padding-top: 27px;
						margin-left: 93px;
						border-radius: 10px;
						transition: all 0.3s;
						opacity: 0;
						transform: translateY(30%);
					}
					.box-name {
						margin-top: 10px;
						font-size: 14px;
						line-height: 14px;
						color: #FFFFFF;
						text-align: center;
						transition: all 0.3s;
						opacity: 0;
						transform: translateY(30%);
					}
				}

				&:hover {
					.box-cover {
						background-color: rgba(45,162,212,0.8);
						box-shadow: 0 4px 10px 0 rgba(10,131,186,0.3);
						.box-icon, .box-name {
							opacity: 1;
							transform: translateY(0%);
						}
					}
				}
			}
		}
		.bui-right {
			display: inline-block;
			margin-left: 40px;
			margin-top: 40px;
			vertical-align: top;
			width: 300px;
			height: 347px;
			background: #FBFBFB;
			border-radius: 10px;
			&.jp {
				div {
					span {
						width: 182px;
						font-size: 19px;
					}
				}
			}
			&.en {
				height: 177px;
				div {
					padding: 0 25px;
					text-align: left;
					img {
						margin-right: 10px;
					}
					span {
						font-size: 14px;
					}
				}
			}
			div {
				display: flex;
				justify-content: center;
				align-items: center;
				padding: 0 55px;
				width: 100%;
				height: 50px;
				text-align: center;
				cursor: pointer;
				font-size: 0;
				box-sizing: border-box;
				img,
				span {
					// display: inline-block;
					// vertical-align: middle;
				}
				img {
					width: 50px;
					margin-right: 20px;
				}
				span {
					font-size: 20px;
					color: #444444;
					letter-spacing: 0;
				}
			}
			hr {
				margin: 0 auto;
				width: 240px;
				border: 0;
				height: 1px;
				background-color: #DDDDDD;
			}
		}
	}
	.filter_list {
		margin: 0px auto 30px;
		width: 830px;
		font-size: 0;
		&:before,
		&:after {
			content: "";
			display: table;
			font-size: 0;
		}
		&:after {
			clear: both;
		}
		.filter_btn {
			margin-right: 10px;
			float: left;
			width: 90px;
			height: 30px;
			font-size: 14px;
			text-align: center;
			line-height: 28px;
			background-color: #FFFFFF;
			color: #50BBE5;
			border-radius: 100px;
			border: 1px solid #50BBE5;
			box-sizing: border-box;
			transition: background 0.1s;
			cursor: pointer;
			&.on,
			&:hover {
				background-color: #50BBE5;
				color: #ffffff;
			}
			&.mr0 {
				margin-right: 0;
			}
		}
	}

	@keyframes loading {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}

</style>
